//
//
//
//
//
//
//
//
//
//
//
//
export default {
  props: {
    id: {
      type: Number,
      required: true
    },
    onlyRenderIfRetryable: {
      type: Boolean,
      "default": true
    },
    uploader: {
      type: Object,
      required: true
    }
  },
  data: function data() {
    return {
      state: {
        retryable: false
      },
      _unmounted: false
    };
  },
  mounted: function mounted() {
    this.uploader.on('complete', this._onComplete);
    this.uploader.on('statusChange', this._onStatusChange);
  },
  beforeDestroy: function beforeDestroy() {
    this._unmounted = true;

    this._unregisterEventHandlers();
  },
  methods: {
    _onComplete: function _onComplete(id, name, response) {
      if (id === this.id && !this._unmounted) {
        var retryForbidden = this.isRetryForbidden(response, this.uploader);

        if (!response.success && !retryForbidden && !this.state.retryable) {
          this.$set(this.state, 'retryable', true);
        } else if (response.success && this.state.retryable) {
          this.$set(this.state, 'retryable', false);
        } else if (retryForbidden && this.state.retryable) {
          this.$set(this.state, 'retryable', false);

          this._unregisterEventHandlers();
        }
      }
    },
    _onStatusChange: function _onStatusChange(id, oldStatus, newStatus) {
      if (id === this.id && !this._unmounted && newStatus === 'retrying upload') {
        this.$set(this.state, 'retryable', false);
      }
    },
    _onClick: function _onClick() {
      if (this.state.retryable) {
        this.uploader.methods.retry(this.id);
      }
    },
    _unregisterEventHandlers: function _unregisterEventHandlers() {
      this.uploader.off('complete', this._onComplete);
      this.uploader.off('statusChange', this._onStatusChange);
    },
    isRetryForbidden: function isRetryForbidden(response, uploader) {
      var preventRetryResponseProperty = uploader.options.retry && uploader.options.retry.preventRetryResponseProperty || 'preventRetry';
      return !!response[preventRetryResponseProperty];
    }
  }
};